//tripplan statuses
export const NEW = 'NEW';
export const LOADED_FROM_DB = 'LOADED_FROM_DB';
export const TO_BE_DELETED = 'TO_BE_DELETED';
export const UPDATED = 'UPDATED';
